export const typeList = [
  { id: "day", name: "Day" },
  { id: "date", name: "Date" },
];

export const excludeTypeList = [
  { id: "student", name: "By Student" },
  { id: "level", name: "By Level" },
]
